import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowDown = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16.5"
      fill={fill}
      {...rest}
    >
      <g id="Group_15415" transform="translate(0 .25)">
        <path id="Rectangle_3470" style={{ fill: 'none' }} d="M0 0h16v16H0z" />
        <g id="Group_15414">
          <path
            id="Line_508"
            d="M0 15.75A.75.75 0 0 1-.75 15V0A.75.75 0 0 1 0-.75.75.75 0 0 1 .75 0v15a.75.75 0 0 1-.75.75z"
            transform="translate(8.5 .5)"
          />
          <path
            id="Path_17561"
            d="M8.5 16.25a.748.748 0 0 1-.53-.22l-5-5a.75.75 0 1 1 1.06-1.06l4.47 4.47 4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.748.748 0 0 1-.53.22z"
          />
        </g>
      </g>
    </svg>
  );
};

ArrowDown.displayName = 'ArrowDown';
